import { create } from "zustand";
import type { UploadResponse } from "../types";

interface UploadState {
  teamMembers: string[];
  response?: UploadResponse;
  progress: number;
  isUploading: boolean;
  error?: string;
  setTeamMembers: (members: string[]) => void;
  startUpload: () => void;
  setProgress: (value: number) => void;
  finishUpload: (response: UploadResponse) => void;
  failUpload: (message: string) => void;
  reset: () => void;
}

export const useUploadStore = create<UploadState>((set) => ({
  teamMembers: [],
  progress: 0,
  isUploading: false,
  response: undefined,
  error: undefined,
  setTeamMembers: (members) => set({ teamMembers: members }),
  startUpload: () => set({ isUploading: true, progress: 0, error: undefined }),
  setProgress: (progress) => set({ progress }),
  finishUpload: (response) => set({ response, isUploading: false, progress: 100 }),
  failUpload: (message) =>
    set({ error: message, isUploading: false, progress: 0 }),
  reset: () =>
    set({
      response: undefined,
      progress: 0,
      isUploading: false,
      error: undefined
    })
}));

